import React, { useEffect, useState } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { RecordDataIndicators } from '../../components/RecordDataIndicators';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { AppRoute, AppRoutes } from '../../routes';
import { MeshDeviceProfileData } from '../../components/DeviceProfile/MeshDeviceProfileData';
import { useMeshDeviceDetails } from '../../data/DataProviders/MeshDeviceDetailsProvider';
import { MeshDeviceDetails } from '../../types/device';
import { isDataLoaded } from '../../types';
import { DataIndicators } from '../../components/DataIndicators';
import { GenericToolbar } from '../../components/GenericToolbar';
import { pushAppRoute } from '../../data/domain/route-manager';
import { AcquireSubscription } from '../../components/DeviceProfile/AcquireSubscription';
import { GetPartNumberProvider } from '../../data/DataProviders/GetPartNumberProvider';
export const MeshDeviceProfile: React.FC = () => {
    const selectedOrganization = useSelectedOrganizationData();
    const currentAppRoute = useCurrentAppRoute();
    const history = useHistory();
    const { t } = useLanguageLocale();

    const meshDeviceDetails = useMeshDeviceDetails();
    const currentPage = currentAppRoute.type === 'MeshDeviceProfile' ? 'MeshDeviceProfile' : '';
    const gatewayName = isDataLoaded(meshDeviceDetails) ? meshDeviceDetails.value.profile.name : '';
    const [gatewayDeviceData, setGatewayDeviceData] = useState<MeshDeviceDetails | null>(null);

    useEffect(() => {
        if (isDataLoaded(meshDeviceDetails)) {
            setGatewayDeviceData(meshDeviceDetails.value);
        }
    }, [meshDeviceDetails]);

    const backRoute = (orgId: string, locationId: string, siteId: string, deviceId: string): AppRoute =>
        currentPage === 'MeshDeviceProfile'
            ? { type: 'SiteProfile', orgId: orgId, locationId: locationId, siteId: siteId }
            : {
                  type: 'MeshDeviceProfile',
                  deviceId: deviceId,
                  locationId: locationId,
                  orgId: orgId,
                  siteId: siteId,
              };

    return (
        <>
            <RecordDataIndicators
                recordData={selectedOrganization}
                errorMessage={t('DASHBOARD.ERROR_LOADING_ORGANIZATION')}
                notFoundIcon="Business"
                notFoundMessage={t('DASHBOARD.ORGANIZATION_NOT_FOUND')}
            />
            {isRecordFound(selectedOrganization) &&
                'locationId' in currentAppRoute &&
                'deviceId' in currentAppRoute &&
                'siteId' in currentAppRoute && (
                    <>
                        {currentAppRoute.type === 'MeshDeviceProfile' && (
                            <GenericToolbar
                                showBackButton
                                backButtonOnClick={(): void => {
                                    pushAppRoute(
                                        history,
                                        backRoute(
                                            selectedOrganization.value.id,
                                            currentAppRoute.locationId,
                                            currentAppRoute.siteId,
                                            currentAppRoute.deviceId
                                        )
                                    );
                                }}
                                title={currentPage === 'MeshDeviceProfile' ? gatewayName : ''}
                                subtitle={
                                    currentPage === 'MeshDeviceProfile' ? 'Connected Device Profile' : gatewayName
                                }
                            />
                        )}

                        <DataIndicators
                            emptyIcon="Devices"
                            emptyMessage={'No Device Data'}
                            errorMessage={'No Device Data'}
                            data={meshDeviceDetails}
                            isEmpty={false}
                        />
                        {isDataLoaded(meshDeviceDetails) && (
                            <Switch>
                                <Route exact path={AppRoutes.MeshDeviceProfile}>
                                    <MeshDeviceProfileData
                                        data={gatewayDeviceData}
                                        backAppRoute={backRoute(
                                            selectedOrganization.value.id,
                                            currentAppRoute.locationId,
                                            currentAppRoute.siteId,
                                            currentAppRoute.deviceId
                                        )}
                                    />
                                </Route>
                                <Route exact path={AppRoutes.AcquireSubscription}>
                                    <GetPartNumberProvider siteId={currentAppRoute.siteId}>
                                        <AcquireSubscription />
                                    </GetPartNumberProvider>
                                </Route>
                            </Switch>
                        )}
                    </>
                )}
        </>
    );
};
